import React, { useState, useEffect, useReducer, createContext, Suspense } from "react";

function TestRoute() {
    return (
        <h1>Protected route</h1>
    );
}

export default TestRoute;